import { render } from "./ErrorCmp.vue?vue&type=template&id=5cb255cc&ts=true"
import script from "./ErrorCmp.vue?vue&type=script&lang=ts"
export * from "./ErrorCmp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__